import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

const SaveResponseMessage = forwardRef(({ ...props }, ref) => {
	const [ message, setMessage ] = useState(props?.message ?? '');
	const [ status, setStatus ] = useState(props?.status ?? false);

	const close_time = props?.time ?? 2000;

	const open = (status, msg = "Changes saved") => {
		setMessage(msg);
		setStatus(status);

		setTimeout(() => {
			setMessage('');
			setStatus(false);

			if(props.onClose !== undefined) props.onClose();
		}, close_time);
	};

	useEffect(() => {
		open(props.status, message);
	}, [ props.status ]);

	useImperativeHandle(ref, () => ({
		actionOpen(status, msg = "Changes saved") {
			open(status, msg);
		},
	}), []);

	if(!status) return null;

	let _class = '';
	switch(status) {
		case 'copied':
			_class = 'promotion_copied knk-copy';
			break;

		case 'ko':
			_class = 'changes_not_saved knk-off';
			break;

		case 'ok':
		default:
			_class = 'changes_saved knk-on';
			break;
	}

	return (
		<aside class="gui_save_response_message">
			<div>
				<p class={_class}>{message}</p>
			</div>
		</aside>
	);
});

export default SaveResponseMessage;